export const vehicleTypes = {
  "SEDAN": 0,
  "LUXURY_SEDAN": 1,
  "SUV": 2,
  "MINIVAN": 3,
  "WC": 4,
};
